export default function FullWidthDivider(params) {
  const {
    data
  } = params;
  if (!params.data.value) return null;
  const fullWidthCell = document.createElement('div');
  fullWidthCell.classList.add('w5-full-width-divider-cell');
  const content = document.createElement('div');
  content.classList.add('w5-full-width-divider-cell__content');
  content.innerText = data.value;
  fullWidthCell.appendChild(content);
  return fullWidthCell;
}